// Bookmark list layouts, mirroring Raindrop's view menu. `value` is what we
// persist; `variant` is passed to <Item> to pick its layout.
export const bookmarkViewOptions = (t) => [
  {
    label: t("common.view.list", "List"),
    value: "list",
    icon: "bi-list-ul",
  },
  {
    label: t("common.view.headlines", "Headlines"),
    value: "headlines",
    icon: "bi-text-left",
  },
  {
    label: t("common.view.cards", "Cards"),
    value: "cards",
    icon: "bi-grid",
  },
];

export const DEFAULT_VIEW = "list";
